import { Avatar, Box, Grid, Paper } from '@mui/material';
import { useStatusCardSmallPlaceholderStyles } from './status-count-card-small-placeholder.styles';
import { useStatusCountCardSmallStyles } from './status-count-card-small.styles';

export function StatusCountCardSmallPlaceholder() {
  const sharedClasses = useStatusCountCardSmallStyles();
  const placeholderClasses = useStatusCardSmallPlaceholderStyles();

  return (
    <Paper className={sharedClasses.card}>
      <Grid container>
        {/* Left side */}
        <Grid size={10}>
          <Box className={placeholderClasses.title} />
          <Box className={placeholderClasses.subitle} />
          <Box className={placeholderClasses.count} />
        </Grid>
        {/* Rigth side */}
        <Grid className={sharedClasses.rightSide} size={2}>
          <Avatar className={placeholderClasses.avatar} style={{ backgroundColor: 'lightgrey' }}>
            {' '}
            {/* Single space char to prevent avatar falling back to default icon */}
          </Avatar>
        </Grid>
      </Grid>
    </Paper>
  );
}
